export enum AddressType {
  Default = 'Default',
  Pickup = 'Pickup',
}
